module.exports = __webpack_public_path__ + "img/background.83ccf4be.jpg";